import React from 'react'
import { TextInput } from '../../../legacy-design-system/form-text'
import { GetFormFieldPropsFn } from '../../../legacy-design-system/form/form-validator'
import { ContrastFormattedMessage } from '../../contrast-formatted-message'

export function SamplingFrequencyInput({
  value,
  onChange,
  getFormFieldProps,
  isReadOnly
}: {
  value: string | number | undefined
  onChange: (value: string | number | undefined) => void
  getFormFieldProps: GetFormFieldPropsFn
  isReadOnly?: boolean
}) {
  return (
    <ContrastFormattedMessage id="detail_nRequests_analyzationFrequency">
      {(frequencyUnits) => (
        <ContrastFormattedMessage id="title_analyzationFrequency">
          {(labelFrequency) => (
            <TextInput
              disabled={isReadOnly}
              required
              id="serverSettings_samplingFrequency"
              type="number"
              label={labelFrequency}
              value={value}
              onChange={onChange}
              {...getFormFieldProps({
                id: 'serverSettings_samplingFrequency'
              })}
              unitLabel={frequencyUnits}
            />
          )}
        </ContrastFormattedMessage>
      )}
    </ContrastFormattedMessage>
  )
}
